var _circle, _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataIconD2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 143,
    viewBox: "0 0 111 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.4712,
    cy: 55.3867,
    r: 55.3867,
    fill: "#F1F1F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.9598,
    y: 54.4929,
    width: 53.774,
    height: 75.4639,
    rx: 7,
    transform: "rotate(2.5 33.9598 54.4929)",
    fill: "#EEEEEE",
    stroke: "#CCCCCC",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25401,
    y: 49.5231,
    width: 57.774,
    height: 79.4639,
    rx: 9,
    transform: "rotate(-7.5 1.25401 49.5231)",
    fill: "#FAFAFA",
    stroke: "#CCCCCC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42019 58.3156C2.84348 53.9351 5.92706 49.9165 10.3075 49.3398L49.7413 44.1483C54.1218 43.5716 58.1404 46.6551 58.7171 51.0356L59.9984 60.7683L4.70152 68.0483L3.42019 58.3156Z",
    fill: "#EEEEEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7002,
    y: 45.427,
    width: 2.32392,
    height: 7.74639,
    rx: 1.16196,
    transform: "rotate(82.5 69.7002 45.427)",
    fill: "#999999"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48.4761,
    y: 32.5947,
    width: 2.32392,
    height: 7.74639,
    rx: 1.16196,
    transform: "rotate(-7.5 48.4761 32.5947)",
    fill: "#999999"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 62.0928,
    y: 34.709,
    width: 2.32392,
    height: 7.74639,
    rx: 1.16196,
    transform: "rotate(37.5 62.0928 34.709)",
    fill: "#999999"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4824,
    y: 70.4121,
    width: 44.9291,
    height: 3.09856,
    rx: 1.54928,
    transform: "rotate(-7.5 10.4824 70.4121)",
    fill: "#DCDCDC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5039,
    y: 85.7725,
    width: 44.9291,
    height: 3.09856,
    rx: 1.54928,
    transform: "rotate(-7.5 12.5039 85.7725)",
    fill: "#DCDCDC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5283,
    y: 101.133,
    width: 44.9291,
    height: 3.09856,
    rx: 1.54928,
    transform: "rotate(-7.5 14.5283 101.133)",
    fill: "#DCDCDC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2905,
    y: 76.5562,
    width: 16.2674,
    height: 3.09856,
    rx: 1.54928,
    transform: "rotate(-7.5 11.2905 76.5562)",
    fill: "#EEEEEE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3149,
    y: 91.9165,
    width: 16.2674,
    height: 3.09856,
    rx: 1.54928,
    transform: "rotate(-7.5 13.3149 91.9165)",
    fill: "#EEEEEE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3359,
    y: 107.277,
    width: 16.2674,
    height: 3.09856,
    rx: 1.54928,
    transform: "rotate(-7.5 15.3359 107.277)",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataIconD2);
export default __webpack_public_path__ + "static/media/no-data-icon-d2.f190cc456a3e0ba38a42acae1644039b.svg";
export { ForwardRef as ReactComponent };